import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { find as _find } from 'lodash';

import EntityStateUpdater from 'component/EntityStateUpdater';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { getDescriptionInCurrentLanguage } from 'helpers/intl';

import Loader from 'components/layout/Loader';
import RichEditorContent from 'components/RichEditorContent';
import Entity from 'components/Entity';
import Data from 'components/Data';

import FormErrors from 'components/forms/FormErrors';
import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';

import { entityMetaMapping } from 'js/constants';
const entityMappingName = entityMetaMapping.pluginSettingsChedriCommsCenter;

class SettingsChedriCommsCenter extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();
  }

  getSettingValue = (settings, name, defaultValue = null) => {
    const setting = _find(settings, ['name', name]);
    return setting ? setting.value : defaultValue;
  };

  getSettingValues = (settings, name, defaultValue = null) => {
    const setting = _find(settings, ['name', name]);
    return setting ? setting.values : defaultValue;
  };

  updateSwitcheryAsString = (name, value) => {
    if (value === true) {
      this.updateEntity(name, 'true');
    } else {
      this.updateEntity(name, 'false');
    }
  };

  componentDidUpdate = prevProps => {
    const { meta, shown, plugin, whiteLabelProject } = this.props;

    if (!prevProps.shown && shown) {
      // create new entity with the white label data
      const whiteLabelPlugin = _find(whiteLabelProject.plugins, ['id', plugin.id]);
      // console.log(whiteLabelPlugin);
      const settings = whiteLabelPlugin.settings ? whiteLabelPlugin.settings : [];
      // console.log(settings);

      const data = {
        allowAnonymousWebrtc: this.getSettingValue(settings, 'allowAnonymousWebrtc', 'true'),
      };
      // console.log(data);

      this.entity = new Entity();
      this.entity.setData(data);
      if (meta[entityMappingName] !== undefined && !meta[entityMappingName].pending) {
        this.entity.setMeta(meta, entityMappingName);

        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (prevProps.shown && !shown) {
      this.setState({ entityLoaded: false });
    }

    if (meta[entityMappingName] !== undefined && !meta[entityMappingName].pending && !this.entity.getMetaLoaded()) {
      this.entity.setMeta(meta, entityMappingName);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();
    const { plugin, whiteLabelProject, onSubmit } = this.props;

    this.changeEntity(this.state.entity.validate(), () => {
      const { entity } = this.state;
      if (entity.isValid) {
        onSubmit(whiteLabelProject.id, plugin.id, entity.processedData);
      }
    });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      formStatus,
      plugin,
    } = this.props;
    const { entity, entityLoaded, entityChanged } = this.state;

    return (
      <div>
        <Data dataName="pluginSettingsChedriCommsCenter" /> {/* fetch meta data */}
        <FormErrors formStatus={formStatus} />
        {!entityLoaded ? (
          <Loader />
        ) : (
          <form method="post" onSubmit={this.formSubmit}>
            <RichEditorContent
              content={
                '<div>' + (getDescriptionInCurrentLanguage(plugin.settings_instructions, appIntl) || '') + '</div>'
              }
            />

            <div className="form-group-attached">
              <div class="form-group form-group-default padding-10">
                <FormSwitchery
                  name="allowAnonymousWebrtc"
                  label="Allow anonymous video and audio calls"
                  value="true"
                  validation={entity.getAllowAnonymousWebrtcValidationResult()}
                  meta={entity.getAllowAnonymousWebrtcMetaInformation()}
                  checked={entity.getAllowAnonymousWebrtc() === 'true'}
                  onChange={this.updateSwitcheryAsString}
                  disabled={formStatus.pending}
                />
              </div>
            </div>

            <div className="text-right m-t-15">
              <Button
                bsSize="lg"
                disabled={formStatus.pending}
                type="submit"
                bsStyle={entityChanged ? 'primary' : 'default'}
              >
                <i className={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                {messages.save}
              </Button>
            </div>
          </form>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.pluginSettingsEdit,
    meta: state.entityMeta,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (whiteLabelId, pluginId, args) => {
      formStatusDispatchHelper(
        'pluginSettingsEdit',
        `/api/whitelabels/${whiteLabelId}/plugins/${pluginId}/settings.json`,
        args,
        'put',
        dispatch
      );
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SettingsChedriCommsCenter)
  )
);
